import {TooltipAttrs} from 'common/components/tooltip/types';

export type ToggleOption = {
  label: string;
  value: string;
  disabled?: boolean;
  icon?: string;
  iconColor?: string;
  // Only one of tooltipLabel or tooltip should be specified
  tooltipLabel?: string;
  tooltip?: TooltipAttrs;
};

export type SelectEvent = CustomEvent<{
  selected: string;
}>;

export enum ToggleTheme {
  TabBar = `tab-bar`,
  TabBarLite = `tab-bar-lite`,
  TabBarHeavy = `tab-bar-heavy`,
  SegmentedController = `segmented-controller`,
}

export enum ToggleSize {
  Medium = `medium`,
  Large = `large`,
}

type ToggleAttrs = {
  selected?: string;
  size?: ToggleSize;
  theme?: ToggleTheme;
  options?: ToggleOption[];
  'icon-only-width-threshold'?: number;
};

// We may want to add e.g. `only-icons-except-selected` in the future
export enum NarrowMode {
  OnlyIcons = `only-icons`,
}

export type ToggleState = {narrowMode: null | NarrowMode};

export type ToggleJsxProps = {
  attrs?: ToggleAttrs;
  on?: {
    select?: (ev: SelectEvent) => void;
  };
};
